import CryptoJS from 'crypto-js'
// 获取url中的参数
export function getRequest(text) {
  var url = text;
  var theRequest = {};
  if (url.indexOf('?') !== -1) {
    var str = url.split('?')[1];
    var strs = str.split('&');
    for (var i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = decodeURIComponent(strs[i].split('=')[1]);
    }
  }
  return theRequest;
}

export function telStart(phone) {
  phone = phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
  return phone;
}

//加密
export function encryption(code) {
  var c = String.fromCharCode(code.charCodeAt(0) + code.length);
  for (var i = 1; i < code.length; i++) {
    c += String.fromCharCode(code.charCodeAt(i) + code.charCodeAt(i - 1));
  }
  return (escape(c).replace(/%/g, '%25'));
}

//解密
export function decryption(code) {
  code = unescape(code);
  var c = String.fromCharCode(code.charCodeAt(0) - code.length);
  for (var i = 1; i < code.length; i++) {
    c += String.fromCharCode(code.charCodeAt(i) - c.charCodeAt(i - 1));
  }
  return c;
}

//获取appid
export function getAppid(url) {
  let appid = url.split('/');
  return appid[appid.length - 2];
}
export function encrypt(word, keyStr){ //加密
  keyStr = keyStr ? keyStr : '_81lianpin888888';
  var key  = CryptoJS.enc.Utf8.parse(keyStr);//Latin1 w8m31+Yy/Nw6thPsMpO5fg==
  var srcs = CryptoJS.enc.Utf8.parse(word);
  var encrypted = CryptoJS.AES.encrypt(srcs, key, {mode:CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7});
  return encrypted.toString();
}
//解密
export function decrypt(word, keyStr){  
  keyStr = keyStr ? keyStr : '_81lianpin888888';
  var key  = CryptoJS.enc.Utf8.parse(keyStr);//Latin1 w8m31+Yy/Nw6thPsMpO5fg==
  var decrypt = CryptoJS.AES.decrypt(word, key, {mode:CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7});
  return CryptoJS.enc.Utf8.stringify(decrypt).toString();
}


// WEBPACK FOOTER //
// ./src/utils/public.js